import { FormikProps } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

import { FormikError, VALIDATION_TYPES } from "@/components/Formik";
import { Group } from "@/components/Group";
import { Header } from "@/components/Header";
import { ILocation } from "@/data/locations";
import { Flex } from "@/eworkitComponents";
import { FormikTypeaheadLocationHints } from "@/views/components/Formik";

export interface IProfileLocationSectionValues {
  location: ILocation | null;
}

export const profileLocationSectionValidationSchema = Yup.object()
  .required()
  .shape({
    location: Yup.object().required(VALIDATION_TYPES.REQUIRED).nullable(true),
  });

interface IProfileLocationSectionProps {
  form: FormikProps<IProfileLocationSectionValues>;
  suggestedLocations?: string[];
}

export const ProfileLocationSection: FC<IProfileLocationSectionProps> = ({ form }) => {
  const { t } = useTranslation("session");

  return (
    <Flex direction="column" innerMargin="sm">
      <Header size="sm" color="black" weight="bold">
        {t("CONSULTANT_PROFILES.DETAIL.SUGGESTED_DATA.PROFILE_FORM.HEADER_LOCATION")}
      </Header>

      <Flex grow={1} direction="column" innerMargin="md">
        <Group
          direction="column"
          required
          label={t("CONSULTANT_PROFILES.DETAIL.SUGGESTED_DATA.PROFILE_FORM.LABEL_LOCATION")}
          width={{ xxs: 12, md: 6 }}>
          <FormikTypeaheadLocationHints
            name="location"
            testName="location"
            value={form.values.location}
            valueKey="name"
            labelKey="name"
            placeholder={t("CONSULTANT_PROFILES.DETAIL.SUGGESTED_DATA.PROFILE_FORM.PLACEHOLDER_LOCATION")}
          />
          <FormikError name="location" data-test="error-location" />
        </Group>
      </Flex>
    </Flex>
  );
};
